module.exports = __webpack_public_path__ + "static/WORLD2-709a48ef95347a4718bfbda2cad39998.jpg";